import CryptoJS from 'crypto-js';
const firebaseProjectURL = import.meta.env.VITE_FIREBASE_PROJECT_URL || process.env.FIREBASE_PROJECT_URL;
const appSecretKey = import.meta.env.VITE_APP_SECRET_KEY || process.env.APP_SECRET_KEY;
const devServer = import.meta.env.VITE_APP_ENV === 'dev' || false;

// Custom Error class for Config related errors
// Static method to decrypt a string - No use right now.... 
export const decryptString = (encryptedString) => {
    const bytes = CryptoJS.AES.decrypt(encryptedString, appSecretKey);
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedString;
}
  
// static method to decrypt config data received and convert it to JSON object
export const getDecryptedObject = (encryptedData) => {

    const bytes = CryptoJS.AES.decrypt(encryptedData, appSecretKey);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    
    // Convert JSON into an Object
    const configData = JSON.parse(decryptedData);
    
    return configData;
}

// Static method to encrypt config data and convert it to a string. 
export const getEncryptedObject = (data) => {
    const jsonValue = JSON.stringify(data);
    const encryptedValue = CryptoJS.AES.encrypt(jsonValue, appSecretKey).toString();
    return encryptedValue
}

// callFirebaseGetFunction - This local function will call a Firebase function and return the data
const callFirebaseGetFunction = async (logsEnabled, functionUrl) => {
 
    try {   
        if (logsEnabled) {
            console.log("[defaultsService.callFirebaseGetFunction] - Firebase Function URL: " + functionUrl);
        }
        const response = await fetch(functionUrl);
        if (!response.ok) {
            throw new Error('[defaultsService.callFirebaseGetFunction] - Network response was not ok');
        } else {
                const receivedData = await response.text();
                let data;
                try {
                    // Check if the returned string is a JSON, otherwise, its encrypted data.
                    data = JSON.parse(receivedData);
                    // if(logsEnabled) {
                    //     console.log("[defaultsService.callFirebaseGetFunction] - Unencrypted Data received: ");
                } catch {
                    // since the data is not JSON, it must be encrypted
                    // if(logsEnabled) {
                    //     console.log("[defaultsService.callFirebaseGetFunction] - Encrypted Data received: ");
                    // }
                    data = await getDecryptedObject(receivedData);
                }
                return data;
        }
    } catch (error) {
            if(logsEnabled) console.error('[defaultsService.callFirebaseGetFunction] Unknown Exception: ', error.message);
            throw new Error(error.message);
    }    

}

// callFirebasePostFunction - This local function will call a Firebase function and post the data
const callFirebasePostFunction = async (appSettings, functionUrl, dataToBePosted) => {

    try {   

        if (appSettings.enableLogs) {
            console.log("[api.callFirebasePostFunction] - Firebase Function URL: " + functionUrl);
            console.log("[api.callFirebasePostFunction] - PayLoad: " + dataToBePosted);
        }

        const response = await fetch(functionUrl, {
            method: 'POST',
            headers: {
                //'Content-Type': appSettings.enableEncryption ? 'application/text' : 'application/json',
                // Content will always be json as the payload will have data object which will be string or an object
                'Content-Type': 'application/json',
            },
            body: dataToBePosted
        });

        if (!response.ok) {
            let responseText = '';
            try {
                responseText = await response.text();
            } catch (readErr) {
                responseText = 'Error reading response text from the function call ' + readErr.message;
            }

            let detailedMessage = '';
            if (responseText) {
                try {
                    const parsed = JSON.parse(responseText);
                    const details = parsed?.error?.details ?? parsed?.details ?? null;
                    const detailMessage =
                        details?.message ||
                        details?.reason ||
                        details?.error ||
                        '';
                    detailedMessage =
                        detailMessage ||
                        parsed?.error?.message ||
                        parsed?.message ||
                        '';

                    // If details is an object and no better message exists, stringify it for diagnostics.
                    if (!detailedMessage && details && typeof details === 'object') {
                        try { detailedMessage = JSON.stringify(details); } catch (_) { detailedMessage = String(details); }
                    }
                } catch {
                    detailedMessage = responseText;
                }
            }

            const httpPrefix = `[api.callFirebasePostFunction] - ${response.statusText}`;
            const finalMessage = detailedMessage ? `${httpPrefix}: ${detailedMessage}` : `${httpPrefix}: Network response was not ok`;
            throw new Error(finalMessage);
        } else {
            const responseText = await response.text();
            let data;
            try {
                data = JSON.parse(responseText);
                if(appSettings.enableLogs) {
                    console.log("[api.callFirebasePostFunction] - Data fetched: " + JSON.stringify(data));
                }
            } catch {
                if(appSettings.enableLogs) {
                    console.log("[api.callFirebasePostFunction] - Encrypted Data fetched: " + responseText);
                }
                data = await getDecryptedObject(responseText);
            }
            return data;
        }
    } catch (error) {
        console.error("[createManualReservation] - ", error.message);
        throw new Error(error.message);
    }    
}

const getDocumentById = async (collectionName, documentId) => {

    let logsEnabled = false;
    const functionName = 'getDocument';  

    try {
      if (devServer) logsEnabled = true;
      const functionUrl = `https://${functionName}-${firebaseProjectURL}?collection=${collectionName}&documentid=${documentId}`;

      let data = await callFirebaseGetFunction(logsEnabled, functionUrl);
      return data;

    } catch (error) {
        if (logsEnabled) console.error(error.message);
        throw new Error(error.message);
    }
};

export const getLayoutDefaults = async (docId = 'icnacon-defaults', collectionName = 'appSettings') => {

  let logsEnabled = false;
  if (devServer) logsEnabled = true;

  const layout = await getDocumentById(collectionName, docId);
    if (layout && typeof layout === 'object') {     
        // if (logsEnabled) console.log('[defaultsService] loaded layout defaults:', layout);
        return layout;
    }
    return {};         
  
};

export const getFunctionConfig = async (docId = 'function-config', collectionName = 'appSettings') => {
  
  let logsEnabled = false;
  if (devServer) logsEnabled = true;

//   console.log('[defaultsService] attempting to load function config from DB', `${collectionName}/${docId}`);

  try {
    const config = await getDocumentById(collectionName, docId);

    if (config && typeof config === 'object') {
      return config;
    }
    return {};
  } catch (err) {
    if (logsEnabled) console.error('[defaultsService] failed to load function config from DB', `${collectionName}/${docId}`, err);
    return {};
  }
};

/* Create a manual reservation via callable function.
*  Create a single manual reservation by calling the callable Cloud Function.
* @param {{createdByProfileId:string, eventId:string, layoutId:string, boothId:string, vendorId:string, price:number|null, boothNumber:any, level:any, corner:boolean, metadata:object}} payload
*/
export const createManualReservation = async (payload) => {
  
    if (!payload || !payload.createdByProfileId || !payload.eventId || !payload.layoutId || !payload.boothId || !payload.vendorId) {
        throw new Error('Missing required fields for createManualReservation');
    }
  
    // console.log('createManualReservation payload:', JSON.stringify(payload, null, 2));

    const functionName = 'adminManageReservation';

    // Callable onCall functions expect a POST body shaped { data: { ... } }
    const functionUrl = `https://${functionName}-${firebaseProjectURL}`;

    const appSettingsLocal = { enableEncryption: true, enableLogs: true };

    // We alwasy Encrypt the payload for manual reservation
    payload = getEncryptedObject(payload);

    try {
      let res = await callFirebasePostFunction(appSettingsLocal, functionUrl, JSON.stringify({data: payload}));
       
      return res;

    } catch (error) {
        if (appSettingsLocal.enableLogs) console.error("[createManualReservation] - ", error.message);
        throw new Error(error.message);
    }
};

export const sfVendorRegistration = async (appSettings, eventId, vendorId) => {
  
    if (!eventId || !vendorId) {
        throw new Error('Missing required fields for sfVendorRegistration');
    }
  
    const functionName = 'sfVendorUpdate';

    // Callable onCall functions expect a POST body shaped { data: { ... } }
    const functionUrl = `https://${functionName}-${firebaseProjectURL}`;

    // const appSettingsLocal = { enableEncryption: true, enableLogs: appSettings.enableLogs };

    // We alwasy Encrypt the payload for manual reservation
    let payload = {eventId, vendorId };
    if (appSettings.enableEncryption) {
        payload = getEncryptedObject(payload);
    }

    try {
      let res = await callFirebasePostFunction(appSettings, functionUrl, JSON.stringify({data: payload}));
       
    if (appSettings.enableLogs)
      console.log("[sfVendorRegistration] Response: ", res);  

      return res;

    } catch (error) {
        if (appSettings.enableLogs) console.error("[createManualReservation] Unknown Error: ", error.message);
        throw new Error(error.message);
    }
};

export default {
  getLayoutDefaults,
  getFunctionConfig,
  createManualReservation,
  sfVendorRegistration
};  
